export default "__VITE_ASSET__DlMe7HpH__"